import { FC } from "react";
import { useTranslation } from "react-i18next";
import FormStepNavigation, { PropsWithoutLabels } from "../../components/forms/FormStepNavigation";

const ContractorStepNavigation: FC<PropsWithoutLabels> = props => {
  const { t } = useTranslation("pages", { keyPrefix: "contractor.newContractor.createDetails.navigation" });
  const nextButtonLabel = t("next");
  const backButtonLabel = t("back");

  return <FormStepNavigation {...props} backButtonLabel={backButtonLabel} nextButtonLabel={nextButtonLabel} />;
};

export default ContractorStepNavigation;
